import request from '@/utils/request';

export default {
  namespaced: true,
  state: {
    cws: [], // 宠物
    
    qclxs: [], // 驱虫类型
    qcyps: [], // 驱虫药品

    ywmcs: [], // 药物名称
    wyldws: [], // 喂药量单位

    ymlxs: [], // 疫苗类型
    ymmcs: [], // 疫苗名称
    ymcxs: [], // 疫苗次序

    swlxs: [], // 食物类型
    jsldws: [], // 进食量单位
  },
  mutations: {
    setCws(state, payload) {
      state.cws = payload;
    },
    setQclxs(state, payload) {
      state.qclxs = payload;
    },
    setQcyps(state, payload) {
      state.qcyps = payload;
    },
    setYwmcs(state, payload) {
      state.ywmcs = payload;
    },
    setWyldws(state, payload) {
      state.wyldws = payload;
    },
    setYmlxs(state, payload) {
      state.ymlxs = payload;
    },
    setYmmcs(state, payload) {
      state.ymmcs = payload;
    },
    setYmcxs(state, payload) {
      state.ymcxs = payload;
    },
    setSwlxs(state, payload) {
      state.swlxs = payload;
    },
    setJsldws(state, payload) {
      state.jsldws = payload;
    },
  },
  actions: {
    async getCws({ commit }) {
      try {
        const res = await request({
          url: '/service/pet/list',
          params: {
            pageSize: 20,
            reasonable: false,
            pageNum: 1,
          },
        });
        commit('setCws', res.rows);
      } catch (error) {}
    },
    async getQclxs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_quchonglx_code',
        });
        commit('setQclxs', res.data);
      } catch (error) {}
    },
    async getQcyps({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_quchongyp_code',
        });
        commit('setQcyps', res.data.concat([{ code: '自定义', name: '自定义' }]));
      } catch (error) {
        commit('setQcyps', [].concat([{ code: '自定义', name: '自定义' }]));
      }
    },
    async getYwmcs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_yaopinmingc_code',
        });
        commit('setYwmcs', res.data);
      } catch (error) {}
    },
    async getWyldws({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_weiyaoliang_code',
        });
        commit('setWyldws', res.data);
      } catch (error) {}
    },
    async getYmlxs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_yimiaolx_code',
        });
        commit('setYmlxs', res.data.concat([{ code: '自定义', name: '自定义' }]));
      } catch (error) {
        commit('setYmlxs', [].concat([{ code: '自定义', name: '自定义' }]));
      }
    },
    async getYmmcs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_yimiaomc_code',
        });
        commit('setYmmcs', res.data.concat([{ code: '自定义', name: '自定义' }]));
      } catch (error) {
        commit('setYmmcs', [].concat([{ code: '自定义', name: '自定义' }]));
      }
    },
    async getYmcxs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_yimiaocs_code',
        });
        commit('setYmcxs', res.data.concat([{ code: '自定义', name: '自定义' }]));
      } catch (error) {
        commit('setYmcxs', [].concat([{ code: '自定义', name: '自定义' }]));
      }
    },
    async getSwlxs({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_swlx_code',
        });
        commit('setSwlxs', res.data);
      } catch (error) {}
    },
    async getJsldws({ commit }) {
      try {
        const res = await request({
          url: '/service/twoPetDictData/two_jsldw_code',
        });
        commit('setJsldws', res.data);
      } catch (error) {}
    },
  },
};
